/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React, { useEffect, useState } from "react";
import { Select, SelectItem, SelectContent, SelectTrigger } from "@/components/ui/select"; // Import custom Select
import { getSymbolInfo } from "../api/api";

function formatSymbolOption(item) {
    if (!item) return "";
    return item.exchange ? `${item.instrument} (${item.exchange})` : item.instrument;
}

const SymbolSelection = ({ selectedSymbol, setSelectedSymbol, watchlist, accountId }) => {
    const [error, setError] = useState(null);

    useEffect(() => {
        if (watchlist && watchlist.length > 0 && !selectedSymbol) {
            // Don't auto-select, let the user choose.
        }
    }, [watchlist, selectedSymbol]);

    // Clear stale error when account becomes available
    useEffect(() => {
        if (accountId !== null && accountId !== undefined && accountId !== '') {
            setError(null);
        }
    }, [accountId]);

    const handleSymbolChange = async (newSymbol) => {
        if (accountId === null || accountId === undefined || accountId === '') {
            setError("Please select an account first.");
            return;
        }
        setError(null); // Clear previous errors

        try {
            await getSymbolInfo(accountId, newSymbol);
            setSelectedSymbol(newSymbol); // Update global state only if validation succeeds
        } catch (err) {
            if (err.message && err.message.includes("not found")) {
                setError(`Symbol "${newSymbol}" not found on this platform.`);
            } else {
                setError("An unexpected error occurred.");
            }
            console.error("Symbol validation error:", err);
        }
    };

    const selectedSymbolDetails = watchlist?.find(item => item.instrument === selectedSymbol);

    return (
        <div className="text-textPrimary flex flex-col items-start space-y-1">
            <div className="flex items-center space-x-2">
                <span className="text-lg font-semibold">Symbol:</span>
                <Select
                    value={selectedSymbol || ""}
                    onValueChange={handleSymbolChange}
                >
                    <SelectTrigger className="w-auto">
                        <span>{selectedSymbolDetails ? formatSymbolOption(selectedSymbolDetails) : (selectedSymbol || "Select Symbol")}</span>
                    </SelectTrigger>
                    <SelectContent>
                        {watchlist && watchlist.map((item) => (
                            <SelectItem key={item.id} value={item.instrument}>
                                {formatSymbolOption(item)}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>
            {error && <p className="text-red-500 text-xs ml-2">{error}</p>}
        </div>
    );
};

export default SymbolSelection;
